//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export class ODSChartsResize {
    constructor(echart, chartId) {
        this.echart = echart;
        this.chartId = chartId;
        this.observer = undefined;
        this.resizeTimeout = undefined;
    }
    static addResizeManagement(echart, chartId) {
        return new ODSChartsResize(echart, chartId);
    }
    get divElement() {
        let div;
        div = document.getElementById(this.chartId) || undefined;
        if (!div) {
            div = this.echart.getDom() || undefined;
            if (div) {
                div = div.parentElement || undefined;
            }
        }
        return div;
    }
    addResizeManagement() {
        this.removeListener();
        const div = this.divElement;
        if (div && ResizeObserver) {
            this.observer = new ResizeObserver(this.resizeChart.bind(this));
            this.observer.observe(div);
        }
        else {
            ODSChartsResize.sizeListeners[this.chartId] = this.resizeChart.bind(this);
            window.addEventListener('resize', ODSChartsResize.sizeListeners[this.chartId]);
        }
    }
    removeResizeManagement() {
        this.removeListener();
        if (this.resizeTimeout) {
            window.clearTimeout(this.resizeTimeout);
            this.resizeTimeout = undefined;
        }
    }
    removeListener() {
        try {
            const div = this.divElement;
            if (div && ResizeObserver) {
                if (this.observer) {
                    this.observer.unobserve(div);
                    this.observer = undefined;
                }
            }
            else if (ODSChartsResize.sizeListeners[this.chartId]) {
                window.removeEventListener('resize', ODSChartsResize.sizeListeners[this.chartId]);
                delete ODSChartsResize.sizeListeners[this.chartId];
            }
        }
        catch (error) { }
    }
    resizeChart() {
        if (this.resizeTimeout) {
            window.clearTimeout(this.resizeTimeout);
            this.resizeTimeout = undefined;
        }
        this.resizeTimeout = window.setTimeout(() => {
            try {
                const chartOptions = this.echart.getOption();
                const opts = {};
                if (chartOptions.animation) {
                    opts.animation = {
                        duration: 'number' === typeof chartOptions.animationDuration ? chartOptions.animationDuration : 1000,
                        easing: chartOptions.animationEasing ? chartOptions.animationEasing : 'cubicInOut',
                    };
                }
                this.echart.resize(opts);
            }
            catch (error) {
                this.removeListener();
            }
        }, 16);
    }
}
ODSChartsResize.sizeListeners = {};
